import { useState, useRef } from "react";
import { TextInput, SearchSelect, SearchSelectItem, Icon } from "@tremor/react";
import { XCircleIcon } from "@heroicons/react/solid";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";

const AddCase = ({ handleClickAddCaseModal, cases, handleAddCase }) => {
  const [arkat, setArkat] = useState("");
  const [kwdikos, setKwdikos] = useState("");
  const [court, setCourt] = useState("");
  const [note, setNote] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const errRef = useRef();

  const [errMsg, setErrMsg] = useState("");
  const [courtError, setCourtError] = useState("");

  const courts = [
    "ΣτΕ",
    "ΔΕφ Αθηνών",
    "ΔΕφ Θεσσαλονίκης",
    "ΔΕφ Πειραιά",
    "ΔΠρ Αθηνών",
    "ΔΠρ Θεσσαλονίκης",
    "ΔΠρ Πειραιά",
    "ΔΕφ Κομοτηνής",
    "ΔΠρ Αλεξανδρούπολης",
    "ΔΠρ Καβάλας",
    "ΔΠρ Κομοτηνής",
    "ΔΠρ Βέροιας",
    "ΔΠρ Σερρών",
    "ΔΠρ Κοζάνης",
    "ΔΕφ Ιωαννίνων",
    "ΔΠρ Ιωαννίνων",
    "ΔΕφ Λάρισας",
    "ΔΠρ Βόλου",
    "ΔΠρ Λάρισας",
    "ΔΠρ Τρικάλων",
    "ΔΠρ Κέρκυρας",
    "ΔΕφ Πάτρας",
    "ΔΠρ Αγρινίου",
    "ΔΠρ Μεσολογγίου",
    "ΔΠρ Πάτρας",
    "ΔΠρ Πύργου",
    "ΔΠρ Λαμίας",
    "ΔΠρ Λιβαδειάς",
    "ΔΠρ Χαλκίδας",
    "ΔΕφ Τρίπολης",
    "ΔΠρ Καλαμάτας",
    "ΔΠρ Κορίνθου",
    "ΔΠρ Ναυπλίου",
    "ΔΠρ Τρίπολης",
    "ΔΠρ Μυτιλήνης",
    "ΔΠρ Ρόδου",
    "ΔΠρ Σύρου",
    "ΔΕφ Χανίων",
    "ΔΠρ Ηρακλείου",
    "ΔΠρ Χανίων",
  ];
  const links = [
    "ste/pageste/stepage",
    "defeteioath",
    "defeteiothe",
    "defeteiopei",
    "dprotodikeioath",
    "dprotodikeiothe",
    "dprotodikeiopei",
    "defeteiokom",
    "dprotodikeioale",
    "dprotodikeiokav",
    "dprotodikeiokom",
    "dprotodikeiover",
    "dprotodikeioser",
    "dprotodikeiokoz",
    "defeteioiwa",
    "dprotodikeioiwa",
    "defeteiolar",
    "dprotodikeiovol",
    "dprotodikeiolar",
    "dprotodikeiotri",
    "dprotodikeioker",
    "defeteiopat",
    "dprotodikeioagr",
    "dprotodikeiomes",
    "dprotodikeiopat",
    "dprotodikeiopyr",
    "dprotodikeiolam",
    "dprotodikeioliv",
    "dprotodikeioxal",
    "defeteiotrp",
    "dprotodikeiokal",
    "dprotodikeiokor",
    "dprotodikeionaf",
    "dprotodikeiotrp",
    "dprotodikeiomyt",
    "dprotodikeiorod",
    "dprotodikeiosyr",
    "defeteioxan",
    "dprotodikeiohra",
    "dprotodikeioxan",
  ];

  const options = courts.map((e, i) => {
    let label = e;

    return { label, value: links[i] };
  });

  // const gakRef = useRef();

  // useEffect(() => {
  //   gakRef.current.focus();
  // }, [])

  // const handleChange = (event) => {
  //   setCourt(event.target.value);
  // };

  const handleCourtChange = (value) => {
    setCourt(value ?? "");
    // Validate court selection
    if (!value || value === "") {
      setCourtError("Παρακαλώ επιλέξτε δικαστήριο");
    } else {
      setCourtError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate court field before submission
    if (!court || court === "") {
      setCourtError("Παρακαλώ επιλέξτε δικαστήριο");
      return;
    }

    try {
      if (cases.find((e) => e.arkat === arkat && e.court === court)) {
        setErrMsg("Έχετε ξανακαταχωρήσει την υπόθεση");
        return;
      }
      if (
        cases.length < 550 &&
        !cases.find((e) => e.arkat === arkat && e.court === court)
      ) {
        await axiosPrivate.post(
          "/adjustice",
          JSON.stringify({ arkat, kwdikos, court, note }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
        handleClickAddCaseModal();
        handleAddCase({ arkat, kwdikos, court, note });
      }

      // forceUpdate()
      //console.log(JSON.stringify(response));
    } catch (err) {
      console.error(err);
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  return (
    <section className="container_ac">
      <p
        ref={errRef}
        className={errMsg ? "errmsg" : "offscreen"}
        aria-live="assertive"
      >
        {errMsg}
      </p>

      <div className="close_addcase">
        <Icon
          onClick={() => handleClickAddCaseModal()}
          className="cursor-pointer"
          icon={XCircleIcon}
          size="lg"
          color="red"
          tooltip="Κλείσιμο"
        />
      </div>
      {/* <span></span> */}
      {/* <h1>Sign In</h1> */}
      <form className="form" onSubmit={handleSubmit}>
        {/* <label htmlFor="username">Email:</label> */}
        <div className="input-container ic1">
          <TextInput
            placeholder="Αρ.Κατάθεσης"
            type="text"
            id="arkat"
            onValueChange={(value) => setArkat(value)}
            value={arkat}
            style={{ fontSize: "18px", height: "48px" }}
            required
          />
        </div>
        <div className="input-container ic2">
          <TextInput
            placeholder="Κωδικός"
            type="number"
            id="kwdikos"
            onValueChange={(value) => setKwdikos(value)}
            value={kwdikos}
            style={{ fontSize: "18px", height: "48px" }}
            required
          />
        </div>
        <div className="input-container ic2">
          <SearchSelect
            id="court"
            name="court"
            value={court}
            onValueChange={handleCourtChange}
            error={courtError !== ""}
            errorMessage={courtError}
            placeholder="Δικαστήριο"
          >
            {options.map((option) => (
              <SearchSelectItem key={option.label} value={option.value}>
                {option.label}
              </SearchSelectItem>
            ))}
          </SearchSelect>
        </div>
        <div className="input-container ic2">
          <TextInput
            placeholder="Σημείωση"
            type="text"
            id="note"
            onValueChange={(value) => setNote(value)}
            value={note}
            style={{ fontSize: "18px", height: "48px" }}
          />
        </div>

        <button type="text" className="submit">
          Προσθήκη
        </button>
      </form>
    </section>
  );
};

export default AddCase;
